import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { getCategoryList } from '../content/config';

const categories = getCategoryList();

const Header = () => {
  const navigate = useNavigate();
  const today = new Intl.DateTimeFormat('fr-FR', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  }).format(new Date());

  const onSubmitSearch = (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const q = String(formData.get('q') || '').trim();
    navigate(`/recherche?q=${encodeURIComponent(q)}`);
  };

  return (
    <header className="sticky top-0 z-40 border-b border-slate-300 bg-white/95 backdrop-blur">
      <div className="mx-auto max-w-[1400px] px-4">
        <div className="lmd-divider hidden items-center justify-between py-2 text-[11px] uppercase tracking-wider text-slate-500 md:flex">
          <span>{today}</span>
          <span className="font-semibold text-slate-700">Édition numérique</span>
        </div>

        <div className="flex min-h-[92px] items-center justify-between gap-4 py-2">
          <Link to="/" className="shrink-0">
            <div className="flex flex-col items-center">
              <img
                src="/logo-lmd.png"
                alt="Logo LMD"
                className="h-11 w-auto md:h-12"
              />
              <span className="mt-1 text-center font-sans text-[10px] font-black uppercase tracking-[0.18em] text-indigo-700 md:text-[11px]">
                LE VRAI JOURNAL DU DIGITAL
              </span>
            </div>
          </Link>

          <div className="hidden min-w-0 flex-1 items-center lg:flex">
            <nav className="flex min-w-0 items-center gap-4 overflow-x-auto text-[11px] font-bold uppercase tracking-[0.15em] text-slate-600">
              {categories.map((category) => (
                <Link
                  key={category.slug}
                  to={category.slug === 'a-la-une' ? '/a-la-une' : `/categorie/${category.slug}`}
                  className="whitespace-nowrap transition hover:text-indigo-600"
                >
                  {category.label}
                </Link>
              ))}
            </nav>
          </div>

          <form className="relative w-full max-w-[260px] shrink-0 md:max-w-[320px]" onSubmit={onSubmitSearch}>
            <input
              type="search"
              name="q"
              placeholder="Rechercher un sujet..."
              className="w-full rounded-full border border-slate-300 bg-slate-50 py-2 pl-10 pr-4 text-sm text-slate-700 outline-none transition focus:border-indigo-500"
            />
            <SafeIcon
              icon={FiIcons.FiSearch}
              className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400"
            />
          </form>
        </div>

        <div className="flex items-center gap-3 overflow-x-auto pb-3 lg:hidden">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={category.slug === 'a-la-une' ? '/a-la-une' : `/categorie/${category.slug}`}
              className="whitespace-nowrap rounded-full border border-slate-200 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-slate-600"
            >
              {category.label}
            </Link>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;